module.exports = __webpack_public_path__ + "media/startmp4.fc5619c1.mp4";